import React from "react";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import "./multiRecordStyles.css";

class MultiRecordLayout extends React.Component {
  constructor(props) {
    super(props);
    this.scrollContainerRef = React.createRef();
  }

  componentDidMount() {
    // Reset scroll to top when component mounts
    this.resetScroll();
  }

  componentDidUpdate(prevProps) {
    // Reset scroll to top only when loading finishes (isLoadingRecords changes from true to false)
    if (prevProps.isLoadingRecords === true && this.props.isLoadingRecords === false) {
      this.resetScroll();
    }
  }

  resetScroll = () => {
    // Use setTimeout to ensure DOM is fully rendered before resetting scroll
    setTimeout(() => {
      if (this.scrollContainerRef.current) {
        this.scrollContainerRef.current.scrollTop = 0;
      }
    }, 100);
  };

  renderRecord = (record, index) => {
    if (record.isFailed) {
      return (
        <div key={index} className="record-error">
          <h4>SKU {record.sku} - DC {record.dc}: Failed to Load</h4>
          <p style={{ color: "#721c24" }}>{record.errorMessage}</p>
        </div>
      );
    }

    // Use stable timestamp from record creation as part of key
    const uniqueKey = `${record.sku}-${record.dc}-${record.createdAt}`;

    return (
      <div key={index} className="record-container">
        <h4 style={{ marginBottom: "15px", color: "#004085" }}>
          Record {index + 1}: SKU {record.sku} - DC {record.dc}
        </h4>
        <HeaderLayout
          key={`header-${uniqueKey}`}
          headerData={record.header}
          setHeaderInfo={(info) => this.props.onRecordChange(index, 'header', info)}
          lookup={() => {}}
          checkVendor={(type, vendor) => this.props.onCheckVendor(index, type, vendor)}
          setErrorMessage={this.props.setErrorMessage}
          setSuccessMessage={this.props.setSuccessMessage}
        />
        <CardsLayout
          key={`cards-${uniqueKey}`}
          cardsData={record.cards}
          setCardsInfo={(info) => this.props.onRecordChange(index, 'cards', info)}
        />
      </div>
    );
  };

  render() {
    if (!this.props.records || this.props.records.length === 0) {
      return (
        <div className="multi-record-scroll-container" ref={this.scrollContainerRef}>
          <p>No records loaded</p>
        </div>
      );
    }

    return (
      <div className="multi-record-scroll-container" ref={this.scrollContainerRef}>
        {this.props.records.map(this.renderRecord)}
      </div>
    );
  }
}

export default MultiRecordLayout;
